import cn from 'clsx'
import * as React from 'react'
import { DropTarget } from 'react-dnd'
import { SECTION_BLOCK } from './constants'
const blockDropTarget = {
  // drop should return object, actual handling should be in drag source endDrag
  // see https://github.com/react-dnd/react-dnd/issues/557
  drop({ sectionIndex, columnIndex, contentIndex }) {
    return {
      sectionIndex,
      columnIndex,
      contentIndex,
    }
  },
}

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
  }
}

class BlockDropWrapper extends React.Component<{
  isOver: boolean
  connectDropTarget: (...args: Array<any>) => any
  children: React.ReactNode
}> {
  render() {
    const { connectDropTarget, isOver } = this.props
    return connectDropTarget(
      <div
        className={cn({
          'block-drop-over': isOver,
        })}
      >
        {this.props.children}
      </div>,
    )
  }
}

export default DropTarget(
  SECTION_BLOCK,
  blockDropTarget,
  collect,
)(BlockDropWrapper) as any
